import React, {useContext, useEffect, useMemo} from 'react';
import {Typography} from '@mui/material';
import PropTypes from 'prop-types';
import {FloatButtonContext} from '@assets/contexts/floatButtonContext';
import {useWidgetLabelChanged} from '@assets/pages/Widget/WidgetLabelChangedProvider';
import {CAMPAIGN_TEMPLATE_ID} from '@assets/const/campaignTemplate';
import './WidgetWelcomePopup.scss';

/**
 * @param {App.WidgetSetting} settings
 * @param handleClick
 * @param wizard
 * @param isShowNewsletterPopup
 * @returns {Element}
 * @constructor
 */
export default function WidgetWelcomePopup({
  settings,
  handleClick = () => {},
  addActivity,
  wizard = false,
  isShowNewsletterPopup = false,
  isCartBoosterPopup = false,
  isProductRecommendationPopup = false,
  i18nCampaign
}) {
  const {newsletterPopupSettings, welcomePopupSetting} = settings;
  const {i18n} = useContext(FloatButtonContext);

  const {isLabelChanged} = useWidgetLabelChanged();
  const message = useMemo(() => {
    const pathname = window.location.pathname;
    const last = pathname.split('/').pop();
    if (isCartBoosterPopup) {
      return i18nCampaign('message', last);
    }
    if (isProductRecommendationPopup) {
      return i18nCampaign('productMessage', last);
    }
    if (!isLabelChanged && !wizard) {
      return i18n(isShowNewsletterPopup ? 'Teaser message' : 'Welcome visitor teaser');
    }
    return isShowNewsletterPopup
      ? newsletterPopupSettings.teaserMessage
      : welcomePopupSetting.teaserMessage;
  }, [newsletterPopupSettings, welcomePopupSetting, i18n]);

  useEffect(() => {
    addActivity('welcomeVisitorTriggered').then();
  }, []);

  return (
    <div
      className="Avada-FaqsWelcomePopup__Container"
      style={{backgroundColor: welcomePopupSetting.backgroundColor}}
      onClick={handleClick}
    >
      <div className="AvadaFaqs-MUI-WPMessageTextFont" style={{textAlign: 'left'}}>
        <Typography
          className="Avada-FaqsWelcomePopup__Message"
          variant="div"
          style={{fontSize: '13px', color: welcomePopupSetting.textColor}}
        >
          <div
            dangerouslySetInnerHTML={{
              __html: message?.replaceAll('\n', '<br/>').replaceAll('\\n', '<br/>')
            }}
          />
        </Typography>
      </div>
    </div>
  );
}

WidgetWelcomePopup.propTypes = {
  settings: PropTypes.object,
  handleClick: PropTypes.func,
  addActivity: PropTypes.func,
  isShowNewsletterPopup: PropTypes.bool,
  popupType: PropTypes.oneOf([
    CAMPAIGN_TEMPLATE_ID.WELCOME_VISITORS,
    CAMPAIGN_TEMPLATE_ID.SUBSCRIBE_NEWSLETTER,
    CAMPAIGN_TEMPLATE_ID.CART_BOOSTER,
    CAMPAIGN_TEMPLATE_ID.PRODUCT_RECOMMENDATION
  ])
};
